import classes from "./Thanks.module.scss";
import Image from '../../../Image/Image';

import thanksIcon from "../../../Assets/Img/Src/Svg/Thanks.svg"

const Thanks = () => {
  return (
    <div className={classes.Thanks}>
      <Image src={thanksIcon}/>
      <p className={classes.Text}>
      Также хотим поблагодарить Заказчика за активные обсуждения возникающих нюансов и активное расширение SKU, что также сильно повлияло на достигнутый результат.
      </p>
    </div>
  )
}



export default Thanks;